import { Grid, Group, Layout, Page } from "@/comn/components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFetch, useGrid, usePage, useTheme, useToast, useStore } from "@/comn/hooks";
import { APIS, URLS, SG_ACSS_DTL_LIST } from "@/tz/go/egaz/osci/ststcl/ptl/services/OsciAcssStstclService";
import { useEffect } from "react";
import { comnUtils } from "@/comn/utils";

/*
 * Access Statistics information details
 * !== 접속 통계 정보 상세 ==!
 */
export const OSCI0501002Q = () => {
    const { pgeUid, menuId } = usePage();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const toast = useToast();
    // const params = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const location = useLocation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const pathParams = useParams(); // { acssDt, acssMenuId }
    const queryParams = new URLSearchParams(useLocation().search);
    const usrId = queryParams.get("usrId");

    const params = {
        ...pathParams,
        ...(usrId && { usrId }),
    };
    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        acssDtlList: useGrid({ defaultSchema: SG_ACSS_DTL_LIST, page: pgeStore?.page, size: pgeStore?.size }),
    };

    const fetch = {
        getAcssStstclDtlList: useFetch({
            api: (page = grid.acssDtlList.page) => {
                return APIS.getAcssStstclDtlList(params, page, grid.acssDtlList.size);
            },
            enabled: !comnUtils.isEmpty(pathParams.acssDt) && !comnUtils.isEmpty(pathParams.acssMenuId),
            key: [grid.acssDtlList.page, grid.acssDtlList.size],
            onError: (e) => console.log(e), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        // Return to the list while retaining the menu context and its stored search conditions.
        // !== 메뉴 컨텍스트와 저장된 검색 조건을 유지하여 목록으로 이동한다. ==!
        onListBtnClick: () => navigate(`${URLS.osci0501001q}?menuId=${menuId}`),
    };

    useEffect(() => {
        grid.acssDtlList.setPage(0);
        fetch.getAcssStstclDtlList.fetch(0);
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.acssDtlList.grid} data={fetch.getAcssStstclDtlList.data?.acssStstclDtlList} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
